import { css } from 'styled-components';
import { rem } from 'polished';
import Config from '@config';
import variables from '@styles/variables';

export const onlineGridElementHeight = () => css`
  min-height: ${rem(variables.size.onlineProductCardHeight)};
  ${Config.MEDIA.FROM_MOBILE} {
    min-height: ${rem(variables.size.onlineProductCardHeightMobile)};
  }
  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    min-height: ${rem(variables.size.onlineProductCardHeightTablet)};
  }
`;

export const offlineGridElementHeight = () => css`
  min-height: ${rem(variables.size.offlineProductCardHeight)};
  ${Config.MEDIA.FROM_MOBILE} {
    min-height: ${rem(variables.size.offlineProductCardHeightMobile)};
  }
  ${Config.MEDIA.FROM_TABLET_PORTRAIT} {
    min-height: ${rem(variables.size.offlineProductCardHeightTablet)};
  }
`;
